import script from "./delete-meeting-modal.vue?vue&type=script&lang=js"
export * from "./delete-meeting-modal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__